import axios from "axios";

export const submitFeedback = (data) =>
  axios.post("/api/app/feedback", data, { withCredentials: true });

export const adminGetFeedbacks = (query) => {
  const url = axios.getUri({ url: "/api/admin/feedback", params: query });
  return axios.get(url, { withCredentials: true });
};

export const adminGetFeedbackDetail = (id) =>
  axios.get(`/api/admin/feedback/${id}`, { withCredentials: true });

export const adminDeleteFeedback = (id) =>
  axios.delete(`/api/admin/feedback/${id}`, { withCredentials: true });
